import { asyncRouterMap, constantRouterMap } from '@/router'
import _ from 'lodash';


/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
 function hasPermission(roles, route) {
   if (route.meta && route.meta.role && route.meta.role.length > 0) {
     return _.intersection(roles, route.meta.role).length > 0;
   } else {
     //不需要权限
     return true
   }
 }

// function hasPermission(roles, route) {
//   if (route.meta && route.meta.role) {
//     return roles.some(role => route.meta.role.indexOf(role) >= 0)
//   } else {
//     return true
//   }
// }

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  let accessedRouters = [];
  asyncRouterMap.forEach(function(route, i){
    let tempRoute = _.cloneDeep(route);
    if(route.children && route.children.length > 0){
      let child = [];
      route.children.forEach(function(item, j){
        if(hasPermission(roles, item)){
           child.push(item);
        }
      })
      tempRoute.children = child;
      accessedRouters.push(tempRoute);
    }
  })
  return accessedRouters
}

// function filterAsyncRouter(asyncRouterMap, roles) {
//   const accessedRouters = asyncRouterMap.filter(route => {
//     if (hasPermission(roles, route)) {
//       if (route.children && route.children.length) {
//         route.children = filterAsyncRouter(route.children, roles)
//       }
//       return true
//     }
//     return false
//   })
//   return accessedRouters
// }

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = _.concat(constantRouterMap, routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        let accessedRouters
        if (roles.indexOf('admin') >= 0) {
          accessedRouters = asyncRouterMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        }
        //console.log(accessedRouters);
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js